export default __webpack_public_path__ + "static/media/test-ready.d1adfe1c.png";